module.exports = __webpack_public_path__ + "img/img-licitante.22850620.svg";